module.exports = __webpack_public_path__ + "static/media/Website Logo .5cb4f423.png";